<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 15:07:49
 * @FilePath: /smartEarthDemo/src/demo/earth/flooroaming.vue
 * @Description: 
-->
<template>
<div style="height:100%">
    <div id="container"></div>
</div>
</template>
<script>
import util from "../../components/util"
export default {
    data () {
        return {
        viewer:null
        }
    },
    mounted(){
       this.init()
    },
    methods: {
        init () {
            this.viewer=util.getViewer("container",{
                shouldAnimate: true,
                timeline:true,
                animation:true
            });
        Cesium.Math.setRandomNumberSeed(3);

        //Set bounds of our simulation time
        var start = Cesium.JulianDate.fromDate(new Date(2015, 2, 25, 16));
        var stop = Cesium.JulianDate.addSeconds(start, 120, new Cesium.JulianDate());

        //Make sure viewer is at the desired time.
        this.viewer.clock.startTime = start.clone();
        this.viewer.clock.stopTime = stop.clone();
        this.viewer.clock.currentTime = start.clone();
        this.viewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP; //Loop at the end
        this.viewer.clock.multiplier = 1;
        this.viewer.clock.shouldAnimate = true;

        //Set timeline to simulation bounds
        this.viewer.timeline.zoomTo(start, stop);

        var entityPosition = new Cesium.Cartesian3();
        var entityOrientation = new Cesium.Quaternion();
        var rotationMatrix = new Cesium.Matrix3();
        var modelMatrix = new Cesium.Matrix4();

        function computeModelMatrix(entity, time) {
            return entity.computeModelMatrix(time, new Cesium.Matrix4());
        }

        var emitterModelMatrix = new Cesium.Matrix4();
        var translation = new Cesium.Cartesian3();
        var rotation = new Cesium.Quaternion();
        var hpr = new Cesium.HeadingPitchRoll();
        var trs = new Cesium.TranslationRotationScale();

        function computeEmitterModelMatrix() {
            hpr = Cesium.HeadingPitchRoll.fromDegrees(0.0, 0.0, 0.0, hpr);
            trs.translation = Cesium.Cartesian3.fromElements(-4.0, 0.0, 1.4, translation);
            trs.rotation = Cesium.Quaternion.fromHeadingPitchRoll(hpr, rotation);

            return Cesium.Matrix4.fromTranslationRotationScale(trs, emitterModelMatrix);
        }

        var pos1 = Cesium.Cartesian3.fromDegrees(-75.15787310614596, 39.97862668312678);
        var pos2 = Cesium.Cartesian3.fromDegrees(-75.1633691390455, 39.95355089912078);
        var position = new Cesium.SampledPositionProperty();

        position.addSample(start, pos1);
        position.addSample(stop, pos2);

        var entity = this.viewer.entities.add({
            availability : new Cesium.TimeIntervalCollection([new Cesium.TimeInterval({
                start : start,
                stop : stop
            })]),
            model : {
                uri : '/demo/static/data/models/car.glb',
                minimumPixelSize : 64
            },
            viewFrom: new Cesium.Cartesian3(-100.0, 0.0, 30.0),
            position : position,
            orientation : new Cesium.VelocityOrientationProperty(position)
        });
        this.viewer.trackedEntity = entity;
        }
    }
}
</script>
<style scoped>
 #container{
     height: 100%;
 }
</style>